import {ref, watchEffect} from 'vue'
import {defineStore} from 'pinia'
import {api} from 'shared/plugins/api'
import auth from 'shared/plugins/auth'
import {useStore} from './store'

const EXP_API_ENDPOINT = '/experiments/flags'

export const useExperimentStore = defineStore('experiments', () => {
	const store = useStore()
	const experiments = ref({})
	const experimentsLoadedForUser = ref(false)

	watchEffect(() => {
		if (!store.loadingUser && auth.isAuthenticated.value) {
			initialize()
		}
	})

	async function initialize() {
		const experimentList = await getExperimentsData()
		experiments.value = experimentList
		experimentsLoadedForUser.value = true
	}

	async function getExperimentsData() {
		const reqBody = {
			flag_keys: [],
		}

		Object.keys(EXP_NAME_MAPPING).map(id => {
			reqBody.flag_keys.push(EXP_NAME_MAPPING[id]['flag_key'])
		})
		try {
			const response = await api.post(EXP_API_ENDPOINT, reqBody)
			if (response.success) {
				return response.result
			}
		} catch {
			return {}
			// todo: check if tracking / logging is needed here
		}
	}

	return {
		experiments,
		experimentsLoadedForUser,
	}
})

export const EXP_NAME_MAPPING = {
	BEB_UI_BUTTON_SWAP_EXP: {flag_key: 'beb_ui_button_swap_exp', default_value: false},
}
